import React from 'react';
import { HomeGroupLayout, ClassSummary } from 'components';

/**
 * 前台班級報表
 */

export const ClassSummaryPage = () => {
  return (
    <HomeGroupLayout>
      <ClassSummary />
    </HomeGroupLayout>
  );
};
